import LoadsPage from "./LoadsPage";

export default LoadsPage;